import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@emotion/react'

import reportWebVitals from './reportWebVitals'
import { I18nService } from './common/i18n/services/i18n-service'

import './index.css'
import developusTheme from './common/theme/developus-theme'
import AppRouter from './route/AppRoute'
import { KeycloakContextProvider } from './auth/KeycloakContext'
import DevelopusSnackbar from './common/ui/snackbar/DevelopusSnackbar'
import { DevelopusSnackbarContextProvider } from './common/ui/snackbar/DevelopusSnackbarContext'

const languageService = new I18nService()
languageService.init('gr')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <KeycloakContextProvider>
    <DevelopusSnackbarContextProvider>
      <StrictMode>
        <ThemeProvider theme={developusTheme}>
          <AppRouter />
          <DevelopusSnackbar />
        </ThemeProvider>
      </StrictMode>
    </DevelopusSnackbarContextProvider>
  </KeycloakContextProvider>,
)

reportWebVitals()
